// getDisplayTitle.js
// Extracted from various components. Used to get a meaningful title for a document

export function getDisplayTitle(document) {
    if (!document) return 'Unknown Document';

    if (!document.title) {
        return `Document ${document.id || 'Unknown'}`;
    }

    // Check if title looks like an ID (all numbers or very short)
    const isIdLike = /^\d+$/.test(document.title) || document.title.length < 3;

    if (isIdLike) {
        // Try to extract meaningful name from file path
        if (document.file) {
            const fileName = document.file.split('/').pop();
            const nameWithoutExt = fileName.replace(/\.[^/.]+$/, '');
            // Remove random suffixes like _HvYGQKh
            const cleanName = nameWithoutExt.replace(/_[a-zA-Z0-9]{7,}$/, '');
            if (cleanName && cleanName !== document.title) {
                return cleanName.replace(/_/g, ' ');
            }
        }
        return `Document ${document.id}`;
    }

    return document.title;
}
